import { Typography, Box } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { useNavigate } from 'react-router-dom';
import './SelectedStudent.scss';
import { URL_MY_STUDENT } from '../../../../../routes/RouteConstants';

const SelectedStudent = ({ data, onClickedRemoveStudent }) => {
  const navigate = useNavigate();
  const handleOnStudentClick = (student) => {
    navigate(
      URL_MY_STUDENT,
      {
        state: {
          student,
        },
      },
    );
  };

  return (data ? (
    <Box
      data-test={`selected-student-${data.userName}`}
      display='flex'
      flexDirection='row'
      className='selected-student-box'
      justifyContent='space-between'
      onClick={() => handleOnStudentClick(data)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleOnStudentClick(data);
        }
      }}
      aria-hidden='false'
      tabIndex={0}
    >
      <Box className='student-box'>
        <Typography gutterBottom variant='subtitle1' component='p' className='selected-student-subtitle' data-dd-privacy='mask'>
          {`${data.firstName} ${data.lastName}`}
        </Typography>
        <Typography gutterBottom variant='subtitle1' component='p' className='selected-student-subtitle' data-dd-privacy='mask'>
          {`${data.userName}`}
        </Typography>
      </Box>
      <Box data-test={`selected-student-${data.userName}-cancel-action`}>
        <CancelIcon
          className='selected-student-cancel-icon'
          onClick={(e) => { e.stopPropagation(); onClickedRemoveStudent(data); }}
          tabIndex={0}
          onKeyDown={(e) => {
            e.stopPropagation();
            if (e.key === 'Enter' || e.key === ' ') {
              onClickedRemoveStudent(data);
            }
          }}
          aria-hidden='false'
        />
      </Box>
    </Box>
  ) : null);
};

export default SelectedStudent;
